module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.agent_services_data && (Object.keys(_vm.agent_services_data).length > 0)) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#5703a5"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Total accounts added:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(Object.keys(_vm.agent_services_data).length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._l((_vm.agent_services_data), function(business, index) {
    return _c('div', {
      staticClass: "card card-blosq card-blosq-lt"
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": "/agentservices/setupshop"
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9",
      staticStyle: {
        "margin-left": "-0.2em"
      }
    }, [_c('p', [_vm._v(_vm._s(business.business_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Added On: ")]), _c('br'), _vm._v(_vm._s(business.business_reg_date))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bolder",
        "color": "#5703a5"
      }
    }, [_vm._v("Status")]), _c('br'), _vm._v(" "), (business.business_status == 1) ? _c('span', [_vm._v("Active")]) : _c('span', [_vm._v("Pending")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  })], 2)]) : _vm._e()])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 mp0",
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-store",
    staticStyle: {
      "color": "#3b3737",
      "font-size": "18px",
      "margin-top": "0.3em"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df2e892a"}!./src/pages/AgentServices/ShopAccounts/template.html
// module id = 634
// module chunks = 0